export const learningPath = [
  {
    id: "item1",
    iconBg: "bg-green-2",
    iconSrc: "/assets/images/learning/icons/1.svg",
    title: "Leadership development",
    description:
      "Lorem ipsum is placeholder text commonly used in the graphic, print, and publishing industries",
  },
  {
    id: "item2",
    iconBg: "bg-purple-2",
    iconSrc: "/assets/images/learning/icons/2.svg",
    title: "Digital transformation",
    description:
      "Lorem ipsum is placeholder text commonly used in the graphic, print, and publishing industries",
  },
  {
    id: "item3",
    iconBg: "bg-orange-2",
    iconSrc: "/assets/images/learning/icons/3.svg",
    title: "Innovation & design thinking",
    description:
      "Lorem ipsum is placeholder text commonly used in the graphic, print, and publishing industries",
  },
];

export const learningPathTwo = [
  {
    id: 1,
    icon: "assets/images/learning/1.svg",
    title: "Enroll With Us",
    text: "Start your exciting journey with us by opting for one of our premium services",
    bgColor: "bg-green-3",
  },
  {
    id: 2,
    icon: "assets/images/learning/4.svg",
    title: "Document Validation",
    text: "Receive individualised guidance for your document verification",
    bgColor: "bg-yellow-2",
  },
  {
    id: 3,
    icon: "assets/images/learning/3.svg",
    title: "Your Dream College",
    text: "Choose the ideal college from the array of options available to you",
    bgColor: "bg-blue-2",
  },
  {
    id: 4,
    icon: "assets/images/learning/2.svg",
    title: "Fulfill Your Ambitions",
    text: "Make your dream a reality by securing admission to your desired college.",
    bgColor: "bg-orange-3",
  },
];

export const learningPathFive = [
  {
    id: 1,
    title: "Learn with Experts",
    image: "/assets/img/home-5/learning/1.svg",
    description: "Grursus mal suada faci lisis that ipsum ameti consecte.",
  },
  {
    id: 2,
    title: "Learn Anything",
    image: "/assets/img/home-5/learning/2.svg",
    description: "Grursus mal suada faci lisis that ipsum ameti consecte.",
  },
  {
    id: 3,
    title: "Flexible Learning",
    image: "/assets/img/home-5/learning/3.svg",
    description: "Grursus mal suada faci lisis that ipsum ameti consecte.",
  },
  {
    id: 4,
    title: "Industrial Standart",
    image: "/assets/img/home-5/learning/4.svg",
    description: "Grursus mal suada faci lisis that ipsum ameti consecte.",
  },
];

export const learningPathSix = [
  {
    id: 1,
    iconClass: "icon icon-rating-2 text-dark-1",
    title: "Learn anything",
    description:
      "The latest design trends meet hand-crafted templates in Sassio Collection.",
  },
  {
    id: 2,
    iconClass: "icon icon-online-learning-3 text-dark-1",
    title: "Learn together",
    description:
      "The latest design trends meet hand-crafted templates in Sassio Collection.",
  },
  {
    id: 3,
    iconClass: "icon icon-online-learning-2 text-dark-1",
    title: "Learn with experts",
    description:
      "The latest design trends meet hand-crafted templates in Sassio Collection.",
  },
  {
    id: 4,
    iconClass: "icon icon-access text-dark-1",
    title: "Life Time Access",
    description:
      "The latest design trends meet hand-crafted templates in Sassio Collection.",
  },
];

export const learningfeatures = [
  {
    id: 1,
    title: "Hand-picked authors",
  },
  {
    id: 2,
    title: "Easy to follow curriculum",
  },
  {
    id: 3,
    title: "Free courses",
  },
  {
    id: 4,
    title: "Money-back guarantee",
  },
];

export const features = [
  {
    id: 1,
    iconSrc: "/assets/img/home-7/about/icons/1.svg",
    title: "Create Account",
    description:
      "Lorem ipsum is placeholder text commonly used in the graphic, print, and publishing industries",
  },
  {
    id: 2,
    iconSrc: "/assets/img/home-7/about/icons/2.svg",
    title: "Select Courses",
    description:
      "Lorem ipsum is placeholder text commonly used in the graphic, print, and publishing industries",
  },
  {
    id: 3,
    iconSrc: "/assets/img/home-7/about/icons/3.svg",
    title: "Enjoy Your Courses",
    description:
      "Lorem ipsum is placeholder text commonly used in the graphic, print, and publishing industries",
  },
];

export const learningJourney = [
  {
    id: 1,
    imageSrc: "/assets/img/home-5/learning/1.svg",
    title: "Expert Guidance",
    text: "Receive personalised guidance from experienced NEET counsellors.",
    delay: 1,
  },
  {
    id: 2,
    imageSrc: "/assets/img/home-5/learning/2.svg",
    title: "Comprehensive Counseling",
    text: "Get step-by-step support through the entire NEET counselling process.",
    delay: 2,
  },
  {
    id: 3,
    imageSrc: "/assets/img/home-5/learning/3.svg",
    title: "Flexible Support",
    text: "Access our counselling services anytime, anywhere.",
    delay: 3,
  },
  {
    id: 4,
    imageSrc: "/assets/img/home-5/learning/4.svg",
    title: "Up-to-date Information",
    text: "Stay informed of the latest updates and changes in NEET counseling.",
    delay: 4,
  },
];
